export const defaultPaymentHistoryModulesSortPriority = {
  NOTIFICATIONS: 100,
  PAYMENT_HISTORY_SUMMARY: 200,
  PAYMENT_HISTORY_ACTION: 300,
  PAYMENT_HISTORY_RESOURCE: 400,
  TRADELINE_CREDIT_CARDS: 500,
  REVIEW_ENTRY_POINTS: 600,
  TRADELINE_LOANS: 700,
  PAYMENT_HISTORY_OFFERS: 800,
};

export const defaultCreditUsageModulesSortPriority = {
  CREDIT_USAGE_NOTIFICATIONS: 100,
  CREDIT_USAGE_SUMMARY: 200,
  CREDIT_USAGE_ACTION: 300,
  TRADELINES_OPEN_CREDIT_CARD_ACCOUNTS: 400,
  REVIEW_ENTRY_POINTS: 500,
  CREDIT_USAGE_OFFERS: 600,
};

export const defaultCreditAgeModulesSortPriority = {
  NOTIFICATIONS: 100,
  CREDIT_AGE_SUMMARY: 200,
  CREDIT_AGE_ACTION: 300,
  CREDIT_OFFERS_ACTION: 400,
};

export const defaultAccountMixModulesSortPriority = {
  NOTIFICATIONS: 100,
  ACCOUNT_MIX_SUMMARY: 200,
  ACCOUNT_MIX_ACTION: 300,
  TRADELINE_ACCOUNT_MIX_CREDIT_CARDS: 400,
  REVIEW_ENTRY_POINTS: 500,
  TRADELINE_AUTO_LOANS: 600,
  TRADELINE_RENTALS: 700,
  TRADELINE_HOME_LOANS: 800,
  TRADELINE_STUDENT_LOANS: 900,
  TRADELINE_OTHER_LOANS: 1000,
};

export const defaultCreditInquiryModulesSortPriority = {
  NOTIFICATIONS: 100,
  CREDIT_INQUIRIES_SUMMARY: 200,
  HARD_INQUIRIES: 300,
};
